// Redux Utils
import { useSelector, useDispatch } from "react-redux";
import { getUserInfo } from "@/features/user/userThunks";

// React and Libraries
import React, { useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faCamera } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

// Thunks
import { updateImgPerfil } from "@/features/user/userThunks";
import {
  updateImgPerfilEmpresa,
  getEmpresaInfo,
} from "@/features/empresa/empresaThunks";

// Components
import NotificationToast from "@/components/NotificationToast";

// Hooks
import useNotification from "@/hooks/useNotification";

// Assets
import genericUserImage from "@/assets/avatars/avatar-generic.webp";

export default function InfoPerfil({ info }) {
  console.log("Info en InfoPerfil:", info);
  const activeProfile = info?.published
    ? info?.published
    : info?.ambassadorActive
      ? info?.ambassadorActive
      : 0;
  console.log(
    "activeProfile - Info Profile Status:",
    info?.published,
    typeof info?.published,
  );
  console.log(
    "activeProfile - Ambassador Active Status:",
    info?.ambassadorActive,
    typeof info?.ambassadorActive,
  );
  console.log("activeProfile - Active Profile Status:", activeProfile);
  // Redux
  const { user, isAuthenticated, isLoading } = useSelector(
    (state) => state.auth,
  );
  const dispatch = useDispatch();
  const location = useLocation();

  // Detectar si es perfil de empresa
  const isEmpresaProfile = location.pathname.includes("/empresa/");

  const fileInputRef = useRef(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const { notification, showNotification, hideNotification } =
    useNotification();

  // Manejar click en el icono de cámara
  const handleCameraClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Manejar selección de archivo
  const handleFileSelect = async (event) => {
    const file = event.target.files[0];

    if (!file) return;

    // Validar tipo de archivo
    if (!file.type.startsWith("image/")) {
      showNotification("Por favor selecciona una imagen válida", "error");
      return;
    }

    // Validar tamaño (5MB máximo)
    if (file.size > 5 * 1024 * 1024) {
      showNotification("La imagen no debe superar 5MB", "error");
      return;
    }

    try {
      setUploadingImage(true);

      if (isEmpresaProfile) {
        // Actualizar imagen de perfil de empresa
        await dispatch(
          updateImgPerfilEmpresa({
            empresaUid: info.uid,
            imageFile: file,
          }),
        ).unwrap();
      } else {
        // Actualizar imagen de perfil de usuario
        await dispatch(
          updateImgPerfil({
            userId: user.id,
            imageFile: file,
          }),
        ).unwrap();
      }

      // Limpiar el input
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      // Mostrar notificación de éxito
      showNotification(
        "¡Imagen de perfil actualizada exitosamente!",
        "success",
      );
    } catch (error) {
      console.error("Error al actualizar imagen:", error);
      showNotification("Error al actualizar la imagen de perfil", "error");
    } finally {
      setUploadingImage(false);
    }
  };

  return (
    <>
      {/* Notificación Toast */}
      <NotificationToast
        notification={notification}
        onClose={hideNotification}
      />

      <div className="w-full sm:w-1/2 flex flex-row items-center gap-4 px-2 z-10 relative">
        <div className="relative w-1/3 sm:w-fit">
          <LazyLoadImage
            src={info.imgPerfil || genericUserImage}
            alt={`${
              info?.typeProfile
                ? info.nombre
                : `${info.nombre} ${info.apellido}`
            }`}
            className="w-28 h-28 rounded-full border-4 border-white object-cover shadow-lg bg-aw-bluegray"
          />

          {/* Icono de cámara para actualizar imagen - Solo si está autenticado */}
          {isAuthenticated && user && info?.myself && (
            <>
              <button
                onClick={handleCameraClick}
                disabled={uploadingImage || isLoading}
                className={`group absolute -bottom-1 -right-1 w-9 h-9 bg-aw-bluedark rounded-full border-3 border-white shadow-lg flex items-center justify-center transition-all duration-200 hover:bg-aw-green/85 hover:scale-105 ${
                  uploadingImage || isLoading
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer"
                }`}
                title="Cambiar foto de perfil"
              >
                {uploadingImage || isLoading ? (
                  <svg
                    className="animate-spin h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                ) : (
                  <FontAwesomeIcon
                    icon={faCamera}
                    className="text-white group-hover:text-aw-bluedark text-sm"
                  />
                )}
              </button>

              {/* Input de archivo oculto */}
              <input
                ref={fileInputRef}
                type="file"
                accept="image/jpeg,image/png,image/gif,image/webp"
                onChange={handleFileSelect}
                className="hidden"
              />
            </>
          )}
        </div>
        <div className="flex flex-col w-2/3">
          <div className="flex flex-col items-start mt-4 mb-1">
            <span className="text-white text-xl font-bold">
              {info.nombre} {info?.typeProfile ? "" : info.apellido}
            </span>
            {info?.published || info?.ambassadorActive != 0 ? (
              <div className="flex items-center gap-1">
                <FontAwesomeIcon
                  icon={"fa-solid fa-certificate"}
                  className={`${
                    activeProfile == 1
                      ? "text-aw-green"
                      : activeProfile == 0
                        ? "text-gray-500"
                        : activeProfile == 2
                          ? "text-yellow-500"
                          : activeProfile == 3
                            ? "text-red-500"
                            : "text-gray-500"
                  } text-sm`}
                  title={
                    activeProfile == 1
                      ? "Perfil verificado"
                      : activeProfile == 0
                        ? "Perfil no verificado"
                        : activeProfile == 2
                          ? "Verificación en proceso"
                          : activeProfile == 3
                            ? "Perfil rechazado"
                            : "Perfil no verificado"
                  }
                />
                <span
                  className={`${
                    activeProfile == 1
                      ? "text-aw-green"
                      : activeProfile == 0
                        ? "text-gray-500"
                        : activeProfile == 2
                          ? "text-yellow-500"
                          : activeProfile == 3
                            ? "text-red-500"
                            : "text-gray-500"
                  } text-xs`}
                >
                  {activeProfile == 1
                    ? "Perfil verificado"
                    : activeProfile == 0
                      ? "Perfil no verificado"
                      : activeProfile == 2
                        ? "Verificación en proceso"
                        : activeProfile == 3
                          ? "Perfil rechazado"
                          : "Perfil no verificado"}
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>
          {info?.typeProfile && (
            <div className="text-gray-300 text-sm flex items-center gap-2 text-balance">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="text-aw-green"
              />
              {info.direccion}
              {info.comuna && `, ${info.comuna}`}
              {info.ciudad && `, ${info.ciudad}`}
              {info.pais && `, ${info.pais}`}
            </div>
          )}
          {info?.typeProfile && info?.categorias?.length > 0 && (
            <div className="text-gray-300 text-xs flex items-center gap-2">
              <FontAwesomeIcon
                icon={"fa-solid fa-icons"}
                className="text-aw-green"
              />
              {info.categorias.join(", ")}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
